import React from "react";
import "./Icon.scss";
import { icons } from "./icons";

export interface IconInterface {
  className?: string;
  name: keyof typeof icons;
  color?: string;
  size?: number;
}

/**
 * Icon renders an icon which is within the asset/icons folder
 * @param {string} className - For a custom class
 * @param {string} name - Name of the Icon in the folder
 * @param {string} color - Color, can be hex or css varaible (default currentColor)
 * @param {number} size - whole number, returns in rem
 * @returns JSXElement
 */

export const Icon = ({ className, name, color, size = 1 }: IconInterface): JSX.Element => {
  const asset = icons[name];

  const isHex = (iconColor) => {
    // returns whether the colour is a varaible or hex
    const hexRegex = /^#(?:[0-9a-fA-F]{3}){1,2}$/g;
    const found = iconColor.match(hexRegex);
    if (found) {
      return found[0];
    } else {
      return `var(${iconColor})`;
    }
  };
  return (
    <i
      className={`icon ${className ? className : ""}`}
      style={{ "--icon-theme": `${color ? isHex(color) : "currentColor"}`, "--icon-size": `${size}rem` }}
    >
      {asset}
    </i>
  );
};
